/**
 * Supabase Auth 에러 메시지는 영어 원문이라 사용자에게 그대로 보이면 안 된다.
 * 자주 만나는 것만 한국어로 바꾸고, 모르는 건 원문 대신 일반 문구를 보여준다
 * (원문을 그대로 노출하면 내부 정보가 새거나 의미 없는 영어가 뜬다).
 */
export function authErrorMessage(error: { message?: string; code?: string } | null): string {
  const code = error?.code ?? "";
  const message = (error?.message ?? "").toLowerCase();

  if (code === "invalid_credentials" || message.includes("invalid login credentials")) {
    return "이메일 또는 비밀번호가 올바르지 않아요.";
  }
  if (code === "email_not_confirmed" || message.includes("email not confirmed")) {
    return "이메일 인증을 아직 완료하지 않았어요. 메일함의 인증 링크를 눌러주세요.";
  }
  if (code === "user_already_exists" || message.includes("already registered")) {
    return "이미 가입된 이메일이에요. 로그인해주세요.";
  }
  if (code === "weak_password" || message.includes("password should")) {
    return "비밀번호가 너무 약해요. 8자 이상으로 더 복잡하게 만들어주세요.";
  }
  if (
    code === "over_email_send_rate_limit" ||
    code === "over_request_rate_limit" ||
    message.includes("rate limit")
  ) {
    return "요청이 너무 많아요. 잠시 후 다시 시도해주세요.";
  }
  if (message.includes("signups not allowed") || code === "signup_disabled") {
    return "지금은 새로 가입할 수 없어요.";
  }
  return "요청을 처리하지 못했어요. 잠시 후 다시 시도해주세요.";
}
